"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const BurgerWrapper = styled_components_1.default.div(({ theme }) => theme.buttons.burgerButton, {
    display: 'flex',
    alignItems: 'center',
});
const BurgerButtonWrapper = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    testId: 'mobile-menu-control',
})(({ theme }) => theme.buttons.iconBtn, {
    marginLeft: 'auto',
});
const BurgerButton = ({ icon, onClick }) => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BurgerWrapper, null,
            react_1.default.createElement(BurgerButtonWrapper, { icon: icon, onClick: () => onClick() }, t('common:menu.button')))));
};
exports.default = BurgerButton;
//# sourceMappingURL=BurgerButton.js.map